import { createI18n } from 'vue-i18n'
import { UI_LOCALE_MESSAGES, DEFAULT_UI_LOCALE } from './locales'

// Single i18n instance for the app. Only the default locale's messages are
// loaded eagerly (see locales/index.js); every other locale is fetched on
// demand by localeStore.setLocale()/init() via UI_LOCALE_LOADERS, so
// switching languages never blocks first paint with unused translations.
export const i18n = createI18n({
  legacy: false, // Enable Composition API mode
  locale: DEFAULT_UI_LOCALE,
  fallbackLocale: {
    'pt-BR': ['pt', 'en'],
    default: [DEFAULT_UI_LOCALE],
  },
  messages: UI_LOCALE_MESSAGES,
})

// Translate outside of a component's setup(), e.g. from a Pinia store.
// Inside components keep using $t / useI18n() so the strings stay reactive.
export function t(key, params) {
  return i18n.global.t(key, params)
}
